import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-location-bpi.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-location-bpi.component.scss?ngResource";
import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { ViewApplicationBaseComponent } from "../../../shared/view-application-base/view-application-base.component";
import { ApplicationViewService } from "../../../shared/application-view.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { RouterParamsService } from "../../../../shared/services/route-params.service";
import { FormControl, FormGroup } from "@angular/forms";
import { RecipientSelectComponent } from "../../../../shared/components/recipient-components/recipient-select/recipient-select.component";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { ViewApplicationLocationBpiConstants } from "./view-application-location-bpi.constants";
import { take } from "rxjs/operators";
import { WktConverterUtils } from "../../../../shared/utils/wkt-converter-utils";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import { ApiProxyConstants } from "../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../app.config";
import { AppRoutingConstants } from "../../../../app-routing.constants";
import { UrlConstants } from "../../../../shared/constants/url.constants";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { LookupConstants } from "../../../../shared/constants/lookup.constants";
let ViewApplicationLocationBpiComponent = class ViewApplicationLocationBpiComponent extends ViewApplicationBaseComponent {
    applicationViewService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appController;
    changeDetectorRefs;
    routerParamsService;
    ownersComponentRef;
    propertiesForm;
    detailsFormGroupName = ViewApplicationLocationBpiConstants.DETAILS_FORM_GROUP_NAME;
    hasBpamsReferenceNumberLabel = ViewApplicationLocationBpiConstants.HAS_BPAMS_REFERENCE_NUMBER_TEXT_PLACEHOLDER;
    descriptionLabel = ViewApplicationLocationBpiConstants.DESCRIPTION_TEXT_PLACEHOLDER;
    bpamsReferenceNumberControl = ViewApplicationLocationBpiConstants.BPAMS_APPLICATION_REFERENCE_NUMBER_CONTROL;
    erfNoControl = ViewApplicationLocationBpiConstants.ERF_NO_CONTROL;
    subdivisionControl = ViewApplicationLocationBpiConstants.SUBDIVISION_CONTROL;
    allotmentControl = ViewApplicationLocationBpiConstants.ALLOTMENT_CONTROL;
    farmNoControl = ViewApplicationLocationBpiConstants.FARM_NO_CONTROL;
    sgCodeControl = ViewApplicationLocationBpiConstants.SG_CODE_CONTROL;
    addressControl = ViewApplicationLocationBpiConstants.ADDRESS_CONTROL;
    erfSizeControl = ViewApplicationLocationBpiConstants.ERF_SIZE_CONTROL;
    ownerControl = ViewApplicationLocationBpiConstants.OWNER_CONTROL;
    erfNoTextPlaceHolder = ViewApplicationLocationBpiConstants.ERF_NO_TEXT_PLACEHOLDER;
    hasBpamsReferenceNumberFormControlName = ViewApplicationLocationBpiConstants.HAS_BPAMS_REFERENCE_NUMBER_FORM_CONTROL_NAME;
    bpamsReferenceNumberTextPlaceHolder = ViewApplicationLocationBpiConstants.BPAMS_REFERENCE_NUMBER_TEXT_PLACEHOLDER;
    subdivisionTextPlaceHolder = ViewApplicationLocationBpiConstants.SUBDIVISION_TEXT_PLACEHOLDER;
    allotmentTextPlaceHolder = ViewApplicationLocationBpiConstants.ALLOTMENT_TEXT_PLACEHOLDER;
    farmNoTextPlaceHolder = ViewApplicationLocationBpiConstants.FARM_NO_TEXT_PLACEHOLDER;
    sgCodeTextPlaceHolder = ViewApplicationLocationBpiConstants.SG_CODE_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = ViewApplicationLocationBpiConstants.ADDRESS_TEXT_PLACEHOLDER;
    erfSizeTextPlaceHolder = ViewApplicationLocationBpiConstants.ERF_SIZE_TEXT_PLACEHOLDER;
    descriptionFormControlName = ViewApplicationLocationBpiConstants.DESCRIPTION_FORM_CONTROL_NAME;
    applicationTypeFormControlName = ViewApplicationLocationBpiConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    applicantFormControlName = ViewApplicationLocationBpiConstants.APPLICANT_FORM_CONTROL_NAME;
    applicantAgentFormControlName = ViewApplicationLocationBpiConstants.APPLICANT_AGENT_FORM_CONTROL_NAME;
    propertiesFormControlName = ViewApplicationLocationBpiConstants.PROPERTIES_FORM_CONTROL_NAME;
    centroidFormControlName = ViewApplicationLocationBpiConstants.CENTROID_FORM_CONTROL_NAME;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeLabel = SharedConstants.REMOVE_LABEL;
    removePropertyLabel = ViewApplicationLocationBpiConstants.REMOVE_PROPERTY_LABEL;
    ownerLabel = ViewApplicationLocationBpiConstants.OWNER_LABEL;
    copyOwnerLabel = ViewApplicationLocationBpiConstants.COPY_OWNER_LABEL;
    propertyHeadingLabel = ViewApplicationLocationBpiConstants.PROPERTY_HEADING_LABEL;
    ownerDisableFilterBy = true;
    ownerDisableAdd = true;
    ownerDisableEditing = true;
    ownerDisableDelete = true;
    ownerShowGroupsDropdown = true;
    ownerGroups = [];
    ownerListLabel = "Owner";
    showOnlyPropertyAndZoningLayers = false;
    showPropertyForm = false;
    subdivisionControlRequired = true;
    farmNoControlRequired = true;
    erfNoControlRequired = true;
    applicantGroups = [];
    isMapLoaded = false;
    yesNoOptions = LookupConstants.YES_NO;
    verificationMessage = ViewApplicationLocationBpiConstants.VERIFICATION_MESSAGE;
    verifyLabel = ViewApplicationLocationBpiConstants.VERIFY_LABEL;
    isVerified = false;
    mapComponent;
    getTrueCentroidSubscription;
    propertiesFormGroupName = ViewApplicationLocationBpiConstants.PROPERTY_FORM_NAME;
    applicationLoaded = false;
    application;
    constructor(applicationViewService, aflaModuleStrategyService, selectedApplicationService, appController, changeDetectorRefs, routerParamsService) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationViewService = applicationViewService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
        this.routerParamsService = routerParamsService;
        this.initForm();
    }
    ngOnDestroy() {
        this.propertiesForm.reset();
        this.propertiesForm.get(this.hasBpamsReferenceNumberFormControlName).enable();
        this.propertiesForm.get(this.descriptionFormControlName).enable();
        this.propertiesForm.get(this.bpamsReferenceNumberControl).enable();
    }
    get getProperties() {
        return this.propertiesForm.get(this.propertiesFormControlName);
    }
    ngOnInit() {
        this.listenForSelectedApplication();
        this.getMetadata();
    }
    loadMetadata(stepMeta) {
        this.ownerGroups = stepMeta.ownerGroup;
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
    }
    getPropertyFormControl(controlName) {
        const items = this.propertiesForm.get(this.propertiesFormControlName);
        return items.controls[0]?.get(controlName);
    }
    handleRouteChange() {
    }
    initForm() {
        this.propertiesForm = this.aflaModuleStrategyService.form.get(this.propertiesFormGroupName);
    }
    listenForSelectedApplication() {
        this.selectedApplicationService.$selectedApplication.pipe(take(1)).subscribe({
            next: (application) => {
                if (application && application.id >= 0 && !this.applicationLoaded) {
                    const params = { $expand: this.aflaModuleStrategyService.expandListForApplicationPartial };
                    this.aflaModuleStrategyService.getApplicationsQuery(params).subscribe({
                        next: (fullApplication) => {
                            if (fullApplication && !this.applicationLoaded) {
                                this.application = fullApplication.value[0];
                                this.setApplicationData();
                                this.applicationLoaded = true;
                            }
                        },
                        error: (err) => this.appController.handleServerErrorMessage("new application", err, CRUDOperation.Get)
                    });
                }
            }
        });
    }
    setApplicationData() {
        if (this.application && this.application.properties && this.application.properties.length > 0) {
            if (!this.getProperties) {
                return;
            }
            else {
                this.getProperties.clear();
                this.propertiesForm.get(this.hasBpamsReferenceNumberFormControlName).setValue(this.application.bpamsReferenceNumber === null ? "No" : "Yes");
                this.propertiesForm.get(this.descriptionFormControlName).setValue(this.application.description);
                this.propertiesForm.get(this.bpamsReferenceNumberControl).setValue(this.application.referenceNumber);
                const propertiesFormArray = this.getProperties;
                this.selectedApplication?.properties?.sort((a, b) => (b?.id - a?.id));
                this.application.properties.forEach((property) => {
                    const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(property.shape, 102100);
                    const geom = JsonUtils.fromJSON(geometryArc);
                    const newPropertiesFormGroup = this.createFormGroup(property, geom);
                    this.setTrueCentroid(geometryArc, newPropertiesFormGroup, propertiesFormArray);
                    this.syncMapGeometries();
                });
            }
        }
    }
    createFormGroup(property, geom) {
        return new FormGroup({
            id: new FormControl(property.id),
            erfNo: new FormControl(property.erfNumber),
            subdivision: new FormControl(property.subdivision),
            allotment: new FormControl(property.allotment),
            farmNo: new FormControl(property.farmNumber),
            sgCode: new FormControl(property.sgCode),
            address: new FormControl(property.address),
            erfSize: new FormControl(property.erfSize),
            geometry: new FormControl(geom),
            centroid: new FormControl(null),
            owners: new FormControl(property.owners)
        });
    }
    setTrueCentroid(geometryArc, newPropertiesFormGroup, propertiesFormArray) {
        const proxyUrl = ApiProxyConstants.URL;
        const gpToolUrl = AppConfig.settings.arcGIS.servicesURL + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
        const url = `${proxyUrl}?${gpToolUrl}`;
        const formData = new FormData();
        formData.append("f", "json");
        formData.append("geometryJSON", JSON.stringify(geometryArc));
        this.getTrueCentroidSubscription = this.applicationViewService.getTrueCentroid(url, formData).subscribe({
            next: (response) => {
                newPropertiesFormGroup.get(this.centroidFormControlName).setValue(response.results[0].value);
                propertiesFormArray.push(newPropertiesFormGroup);
                this.disablePropertyControls(propertiesFormArray.length - 1);
                this.syncMapGeometries();
                this.showPropertyForm = true;
                this.changeDetectorRefs.markForCheck();
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationLocationBpiConstants.TRUE_CENTROID, error, CRUDOperation.Get);
            }
        });
    }
    disablePropertyControls(index) {
        const propertyControl = this.getProperties.controls[index];
        propertyControl.get(this.addressControl).disable();
        propertyControl.get(this.erfNoControl).disable();
        propertyControl.get(this.subdivisionControl).disable();
        propertyControl.get(this.allotmentControl).disable();
        propertyControl.get(this.farmNoControl).disable();
        propertyControl.get(this.sgCodeControl).disable();
        propertyControl.get(this.addressControl).disable();
        propertyControl.get(this.erfSizeControl).disable();
        this.propertiesForm.get(this.hasBpamsReferenceNumberFormControlName).disable();
        this.propertiesForm.get(this.descriptionFormControlName).disable();
        this.propertiesForm.get(this.bpamsReferenceNumberControl).disable();
    }
    syncMapGeometries() {
        const geometries = [];
        this.propertiesForm.get(this.propertiesFormControlName).controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, "Building plans inspectorate graphics", true);
        }
        else {
            this.mapComponent.removeGraphicsFromMap("Building plans inspectorate graphics");
        }
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: RouterParamsService }
    ];
    static propDecorators = {
        ownersComponentRef: [{ type: ViewChild, args: [RecipientSelectComponent,] }],
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
ViewApplicationLocationBpiComponent = __decorate([
    Component({
        selector: "app-view-application-location-bpi",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationLocationBpiComponent);
export { ViewApplicationLocationBpiComponent };
